import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LoginModule } from '../login/login.module';
import { RegistrationComponent } from './registration.component';
//import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
//import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import { SharedModule } from 'src/app/modules/shared.module';

import { CountryPickerModule } from 'src/app/country-picker/country-picker.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
@NgModule({
  declarations: [RegistrationComponent],
  imports: [
    CommonModule,
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    LoginModule,
    // NgxSkeletonLoaderModule,
    //NgxIntlTelInputModule,
    SharedModule,
    CountryPickerModule
  ],
  exports: [RegistrationComponent]
})
export class RegistrationModule { }
